import type { FreelancerPersonalInformationPageLocales } from '../types';

const freelancerPersonalInformationPageLocales: FreelancerPersonalInformationPageLocales =
  {
    dialogueInstructionHeadline: 'Instructions',
    dialogueInstructionParagraph1:
      'We will soon start with filling in some personal information, such as your name, address, and phone number. This is so that we, and the clients know exactly who you are and how we can reach you. Besides this, the clients are interested in the competences that you may have.',

    dialogueInstructionParagraph2:
      "If you don't have some specific information, you can continue with the other components. You can upload the missing information later. You can also continue at another time, if it is not possible for you to finish the sign-up in one go. Please do this within 30 days, because after that we will remove your data for privacy reasons.",
    dialogueInstructionParagraph3:
      'Attention: You cannot start as a freelancer via Tadaah if we have not received all your information and required documents completely.',
    dialogueInstructionParagraph4:
      'Besides this, you will answer some questions about Tadaah.',
    dialogueInstructionParagraph5:
      'You will be guided through our sign-up procedure. Often you will see an overview of your progress through the sign-up flow.',
    dialogueInstructionRequiredInformationList: [
      'Your personal and Company Information',
      'Your registration at the Chamber of Commerce',
      'Registration in the "Personenregister Kinderopvang" (PRK)',
      'Company Liability Insurance',
      'Your received diplomas and certificates',
    ],
    formAddressError:
      'The combination of Postal Code, House Number and House Number Extension is incorrect.',
    formCity: 'City',
    formFirstName: 'First Name',
    formHouseNumber: 'House Number',
    formHouseNumberAddition: 'Extension',
    formLastName: 'Last Name',
    formPhoneNumber: 'Phone Number',
    formPostalCode: 'Postal Code',
    formStreet: 'Street',
    needMoreInformation:
      'We need some more information from you to complete the signup.',
    personalInformationAdded: 'Personal Information Saved',
    profilePicture: 'Profile picture',
    profilePictureAdded: 'Profile Picture uploaded!',
    profileText: 'Profile Text',
    profileTextPlaceholder:
      'Enter a fun, informal profile text (max 255 characters)',
    title: 'Personal information',
    uploadProfilePicture: 'Upload Profile Picture',
  };

export default freelancerPersonalInformationPageLocales;
